module.exports = __webpack_public_path__ + "static/media/ajax-icon-7.bd187668.jpg";